// client/src/components/ticketing/PriceNote.jsx
//
// "Price goes up to $30 on Nov 1" / "12 left at this price" under a ticket
// tier on the public page and in checkout (Growth Phase 3 price phases). The
// server works both out (ticketingService.tierPricing); this only formats.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/currencyUtils';

export default function PriceNote({ tier, className = 'text-xs mt-1 font-semibold text-orange-700 dark:text-orange-300' }) {
  const { t } = useTranslation();
  const rise = tier?.priceIncrease;
  const left = tier?.phase?.remaining;
  if (!rise && (left == null || left > 25)) return null;

  const parts = [];
  if (left != null && left <= 25) {
    parts.push(t('ticketing.landing.leftAtPrice', '{{count}} left at this price', { count: left }));
  }
  if (rise) {
    const when = new Date(rise.at).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
    parts.push(t('ticketing.landing.priceGoesUp', 'Price goes up to {{price}} on {{when}}', {
      price: formatCurrency(rise.price, tier.currency), when,
    }));
  }
  return <div className={className} data-testid={`price-note-${tier.id}`}>{parts.join(' · ')}</div>;
}
